import type { SnowplowEvent } from 'analytics/snowplow/events'
import { activateCampaignEvent } from 'analytics/snowplow/events'

export function getExperimentActivationEvent(
  experimentKey: string,
  experiment: App.OptimizelyExperimentDetails,
): SnowplowEvent | undefined {
  if (!experiment.campaignId || !experiment.experimentId) {
    return
  }

  const variationId = experiment.variation?.[experiment.variationKey]
  if (!variationId) {
    return
  }

  return activateCampaignEvent(
    experiment.campaignId,
    experiment.experimentId,
    variationId,
  )
}
